import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
// import { map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class MediaManagerService {
  parentId: number;
  changeParentId: Subject<number> = new Subject<number>();
  isNewFolder: boolean = false;
  changeisNewFolder: Subject<boolean> = new Subject<boolean>();

  private mediaDataSubject = new BehaviorSubject<any>(null);
  private folderDataSubject = new BehaviorSubject<any>(null);

  media$: Observable<any> = this.mediaDataSubject.asObservable();
  folder$: Observable<any> = this.folderDataSubject.asObservable();

  constructor(private http: HttpClient) {
    // this.getFolders(0)
    //   .pipe(
    //     tap((res: any) => {
    //       this.mediaDataSubject.next(res);
    //       this.folderDataSubject.next(res);
    //     })
    //   )
    //   .subscribe();

    // this.changeParentId.subscribe((value) => {
    //   this.parentId = value;
    // });
  }

   
  public getMediaDetailsbyCultureId(cultureId: number, filename: any) {
    return this.http.post<any>(
      `/media/meta/${cultureId}`,
      filename
    );
  }

  public geFolderDetailsbyCultureId(cultureId: number, folderName: string) {
    return this.http.get<any>(
      `/media/folder/${cultureId}/${folderName}`
    );
  }
 
  public getFoldersMedia(folderId: number): Observable<any> {
    let id =
      folderId != 0 && folderId != undefined ? "/?folderId=" + folderId : "";
    return this.http.get<any>("/media/list" + id);
  }
  
  public isParentIdChanged() {
    this.changeParentId.next(this.parentId);
  }

  public isNewFolderChanged() {
    this.changeisNewFolder.next(this.isNewFolder);
  }
}
